import { FormField } from './form-field';

export class FormFieldTextBox extends FormField<string> {
  controlType = 'textbox';
  type = 'text';
  // cssClasses = 'row column form-row form-control-wrapper required';

  constructor(options: {} = {}) {
    super(options);
    // this.type = options['type'] || '';
    this.cssClasses = options['cssClasses'] || '';
  }

}
